import React from 'react';
import { arc } from 'd3-shape';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const arcGenerator = arc().cornerRadius(5);

function CircularProgressBar(props) {
  const {
    width,
    arcWidth,
    value,
    className,
    children,
    unfilledArcClassName,
    filledArcClassName
  } = props;
  const height = width;
  const arcOuterRadius = width / 2;
  const arcInnerRadius = width / 2 - arcWidth;
  const progressArc = React.useCallback(v => arcGenerator({
    endAngle: 2 * Math.PI * v,
    innerRadius: arcInnerRadius,
    outerRadius: arcOuterRadius,
    startAngle: 0
  }), [arcInnerRadius, arcOuterRadius]);
  const unfilledPathData = React.useMemo(() => progressArc(1), [progressArc]);
  const filledPathData = React.useMemo(() => progressArc(value / 100), [progressArc, value]);
  const radius = width / 2;
  return /*#__PURE__*/React.createElement("svg", {
    className: _cs(styles.progressBar, className),
    height: height,
    width: width
  }, /*#__PURE__*/React.createElement("g", {
    transform: `translate(${radius}, ${radius})`
  }, /*#__PURE__*/React.createElement("path", {
    className: _cs(styles.unfilledArc, unfilledArcClassName),
    d: unfilledPathData ?? undefined
  })), /*#__PURE__*/React.createElement("g", {
    transform: `translate(${radius}, ${radius})`
  }, /*#__PURE__*/React.createElement("path", {
    className: _cs(styles.filledArc, filledArcClassName),
    d: filledPathData ?? undefined
  })), children && /*#__PURE__*/React.createElement("foreignObject", {
    width: width,
    height: height
  }, children));
}

var CircularProgressBar$1 = genericMemo(CircularProgressBar);

export { CircularProgressBar$1 as default };
//# sourceMappingURL=index.js.map
